import {
    ADD_FEED_POST,
    SEO_DESCRIPTION_FORUM,
    SEO_TITLE_FORUM,
    TAB_FORUMS,
    TAB_GROUPS,
} from 'mk/autogenerated/translations/ForumFeedPage.6c6239b92b6cf102841826f4920a74d6'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { addPostUnauthenticated, analyticsStoreEvent } from 'mk2/actions';
import { forumReadFeedTrigger } from 'mk2/apps/forum/actions';
import ForumFeed from 'mk2/apps/forum/containers/ForumFeed/ForumFeed';
import { forumFeedLoad } from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.actions';
import forumFeedPageReducer, {
    ForumFeedInfiniteListState,
    ForumFeedPageState,
    ORDER_BY_NEWEST,
    ORDER_BY_UPDATED,
    OrderBy,
} from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.reducers';
import forumFeedSaga from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.sagas';
import {
    getForumFeedInfiniteListState,
    getForumFeedPageState,
} from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.selectors';
import { ForumFeedRight } from 'mk2/apps/forum/containers/ForumFeed/ForumFeedRight';
import {
    getForumComplaintsStatistics,
    getForumNewestCount,
    getForumNotificationsOn,
    getForumSubscribedCount,
} from 'mk2/apps/forum/reducers';
import {
    BrandDaysCampaignEntity,
    BrandDaysCampaignSchema,
    ComplaintsStatisticsPerPost,
    PostEntity,
    PostSchema,
} from 'mk2/apps/forum/schemas';
import { breadcrumbsForum } from 'mk2/apps/forum/structuredData';
import {
    forumFeedNewestUrl,
    forumFeedUpdatedUrl,
    forumPostNewUrl,
    forumUpdatedUrl,
    forumUrl,
} from 'mk2/apps/forum/urls';
import { groupsSubscribedFeedUrl } from 'mk2/apps/groups/urls';
import { hintsCloseHint } from 'mk2/apps/users/containers/Hints/Hints.actions';
import { FORUM_FEED_HINT_NAME } from 'mk2/apps/users/containers/Hints/Hints.constants';
import hintsSaga from 'mk2/apps/users/containers/Hints/Hints.sagas';
import Btn, { BtnType } from 'mk2/components/Btn';
import { AppName } from 'mk2/containers/Application/Application';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { cacheLast } from 'mk2/helpers/cache';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page, { BrandingProps, HalfpageProps, RightContentSide } from 'mk2/pages/Page';
import {
    AppState,
    getRequestBaseUrl,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
} from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { MenuSelection, UserEntity } from 'mk2/schemas';
import { getDenormalizedEntities, getDenormalizedEntity } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import Helmet from 'react-helmet';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { FORUM_FEED_MENU_ORDERBY } from './ForumFeed.constants';

interface OwnProps {}

interface StateProps {
    after: number;
    posts: PostEntity[];
    hasNext: number;
    hasPrevious: number;
    mobile: boolean;
    notificationsOn: number[];
    requestUser: UserEntity;
    loadingState: LoadingState;
    errorMessage: string;
    baseUrl: string;
    unreadCount: number;
    permissions: string[];
    complaintsStatistics: ComplaintsStatisticsPerPost;
    subscribedCount: number;
    showHint: boolean;
    orderBy: OrderBy;
    brandDaysCampaign: BrandDaysCampaignEntity;
    brandDaysPosts: PostEntity[];
}

interface DispatchProps {
    onAddPostUnauthenticated();
    onCloseHint();
    onForumFeedMenuOrderBy();
    onLoad(orderBy: OrderBy, after?: number);
    onRead();
    onStoreEvent(name: string, props: any);
}

type RouteProps = RouteComponentProps<{}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class ForumFeedPage extends Page<OwnProps, StateProps, DispatchProps> {

    private onAddPostClicked = cacheLast();
    private menuSelection = {
        activeSection: 'forum',
        activeItem: 'feed',
    };

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const parsed = parse(ownProps.location.search);
            const after = parsed.after;

            const orderBy: OrderBy = ownProps.match.url === forumFeedUpdatedUrl ? ORDER_BY_UPDATED : ORDER_BY_NEWEST;

            const pageState: ForumFeedPageState = getForumFeedPageState(state);
            const feedState: ForumFeedInfiniteListState = getForumFeedInfiniteListState(state, orderBy);

            return {
                after,
                baseUrl: getRequestBaseUrl(state),
                complaintsStatistics: getForumComplaintsStatistics(state),
                errorMessage: feedState.errorMessage,
                hasNext: feedState.hasNext,
                hasPrevious: feedState.hasPrevious,
                loadingState: feedState.loadingState,
                mobile: getRequestDeviceMobile(state),
                notificationsOn: getForumNotificationsOn(state),
                orderBy,
                permissions: getRequestPermissions(state),
                posts: getDenormalizedEntities<PostEntity>(state, PostSchema, feedState.ids),
                requestUser: getRequestUser(state),
                showHint: pageState.showHint,
                subscribedCount: getForumSubscribedCount(state),
                unreadCount: getForumNewestCount(state),
                brandDaysCampaign: getDenormalizedEntity<BrandDaysCampaignEntity>(state, BrandDaysCampaignSchema, pageState.brandDaysCampaignId),
                brandDaysPosts: getDenormalizedEntities<PostEntity>(state, PostSchema, pageState.brandDaysPostsIds),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onAddPostUnauthenticated: addPostUnauthenticated,
            onCloseHint: () => hintsCloseHint(FORUM_FEED_HINT_NAME),
            onForumFeedMenuOrderBy: () => menuToggle(FORUM_FEED_MENU_ORDERBY),
            onLoad: forumFeedLoad,
            onRead: () => forumReadFeedTrigger('updated'),
            onStoreEvent: analyticsStoreEvent,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_FORUM;
    }

    public getMetaDescription(props: Props): string {
        return SEO_DESCRIPTION_FORUM;
    }

    public getStructuredData(props: Props): object[] {
        return [breadcrumbsForum(props.baseUrl)];
    }

    public getCanonicalUrl(baseUrl: string, props: Props): string {
        return props.orderBy === ORDER_BY_UPDATED
            ? baseUrl + forumFeedUpdatedUrl
            : baseUrl + forumFeedNewestUrl;
    }

    public render(props: Props): false | JSX.Element {
        const rssLink = props.orderBy === ORDER_BY_UPDATED ? forumUpdatedUrl : forumUrl;
        return (
            <span>
                <Helmet>
                    <link rel="alternate" type="application/atom+xml" href={`${props.baseUrl}/rss${rssLink}`} title={SEO_TITLE_FORUM} />
                </Helmet>
                <ForumFeed {...props} />
            </span>
        );
    }

    public renderRight(props: Props): JSX.Element {
        return (
            <ForumFeedRight {...props} />
        );
    }

    public getRightContentSide(app: AppName, props: Props): RightContentSide {
        return RightContentSide.LeftSide;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return {
            zone: 'Forum Category - Halfpage Sticky (Desktop)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        return {
            zone: 'Forum - Branding',
        };
    }

    public getHeaderTabs(props: Props): (JSX.Element[] | null) {
        return [(
            <Btn
                key="forums"
                type={BtnType.Tab}
                label={TAB_FORUMS}
                link={forumFeedUpdatedUrl}
                active
            />
        ), (
            <Btn
                key="groups"
                type={BtnType.Tab}
                label={TAB_GROUPS}
                link={groupsSubscribedFeedUrl}
            />
        )];
    }

    public getHeaderRight(props: Props): React.ReactNode {
        const { location, onStoreEvent, requestUser, onAddPostUnauthenticated } = props;

        return (
            <Btn
                type={BtnType.Blue}
                label={ADD_FEED_POST}
                icon="fa-plus-circle fa-lg"
                link={isAuthenticated(requestUser) ? forumPostNewUrl : null}
                onClick={this.onAddPostClicked(() => {
                    onStoreEvent('add_thread_clicked', { slug: location.pathname, category: null });
                    if (!isAuthenticated(requestUser)) {
                        onAddPostUnauthenticated();
                    }
                }, location.pathname, requestUser.id)}
            />
        );
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return this.menuSelection;
    }

    public hasMergedForumAndGroups(props: Props): boolean {
        return true;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.forum.forumFeed', forumFeedPageReducer);
        store.injectSaga('containers.forum.forumFeed', forumFeedSaga);

        store.injectSaga('containers.users.hints', hintsSaga);
    }

}
